import React from 'react';
import Rive from '@rive-app/react-canvas-lite';
import { CircularProgress } from '@mui/material';

const AnimatedLoader = () : React.ReactElement => {
    return (
        <div className={'posa post0 posr0 posb0 posl0 aic jcc zi1000'}>
            <div className={'posa aic jcc h50 w50'}>
                <CircularProgress color={'primary'} className={'posr post0 posr0 posb0 posl0'} size={50} />
                <div className='posa w40 h40' style={{ overflow: 'hidden', borderRadius: '50%' }}>
                    <Rive src={`${ASSET_BASE}/assets/icons/${ICONS.project_rive_logo}`} />
                </div>
            </div>
        </div>
    );
};

export default AnimatedLoader;